import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from '../styles/RegisterPage.module.css'; // Importing the CSS module
import videoBackground from '../styles/background.mp4';

const RegisterPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [billingCycle, setBillingCycle] = useState("monthly"); // default

  const [formData, setFormData] = useState({
    companyName: '',
    companyAddress: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    fax: '',
    mcNumber: '',  // Added MC Number
    package: location.state ? location.state.plan : 'Basic',
    password: '',
    confirmPassword: '',
    numberOfAccountants: '',
    numberOfDispatchers: '',
    numberOfDrivers: '',
    numberOfTrucks: '',
     notes: '',
  });

  const [error, setError] = useState('');
  const [agreeToPrivacy, setAgreeToPrivacy] = useState(false); // ✅ Checkbox state
   const packageConfig = {
    Basic: { accountants: 0, dispatchers: 0, drivers: 1, trucks: 1 },
    Standard: { accountants: 0, dispatchers: 0, drivers: 3, trucks: 3 },
    Premium: { accountants: 1, dispatchers: 1, drivers: 5, trucks: 5 },
    Business: { accountants: 2, dispatchers: 2, drivers: 7, trucks: 7 },
    Ultimate: { accountants: 2, dispatchers: 2, drivers: 7, trucks: 7 },
    Enterprise: { accountants: 50, dispatchers: 50, drivers: 50, trucks: 50 },
    "Simple Statement": { accountants: 0, dispatchers: 0, drivers: 0, trucks: 0 },
  };
  useEffect(() => {
    const selected = packageConfig[formData.package];
    if (selected) {
      setFormData((prev) => ({
        ...prev,
        numberOfAccountants: selected.accountants,
        numberOfDispatchers: selected.dispatchers,
        numberOfDrivers: selected.drivers,
        numberOfTrucks: selected.trucks,
      }));
    }
  }, [formData.package]);

    const packagePricing = {
    "Simple Statement": { monthly: 3.99, annual: 1.99 },
    Basic: { monthly: 9.99, annual: 3.99 },
    Standard: { monthly: 19.99, annual: 9.99 },
    Premium: { monthly: 39.99, annual: 19.99 },
    Business: {monthly: 69.99, annual: 49.99 },
    Ultimate: { monthly: 69.99, annual: 49.99 },
    Enterprise: { monthly: 159.99, annual: 129.99 },
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!agreeToPrivacy) {
      setError('You must agree to our Privacy Policy to register.');
      return;
    }
    // Verificare lungime parolă și prezența unei cifre și a unui semn special
    const passwordRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{12,})/;

    if (!passwordRegex.test(formData.password)) {
        setError('Password must be at least 12 characters long and include at least one number and one special character (!, @, #, etc.).');
        return;
    }

    // Validare parole
    if (formData.password !== formData.confirmPassword) {
        setError('Passwords do not match');
        return;
    }

    try {
        const apiUrl = process.env.REACT_APP_API_URL || 'https://api-backend.full-trucking-service.com';

        const sanitizedFormData = { ...formData };
        if (!sanitizedFormData.fax) delete sanitizedFormData.fax;

 const payload = {
  ...formData,
  subscriptionType: billingCycle, // monthly sau annual
  numberOfDispatchers: formData.numberOfDispatchers // îl trimitem explicit
};

const response = await axios.post(`${apiUrl}/registerClient`, payload, {
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});


        // Verificăm răspunsul și navigăm către pagina de confirmare
        if (response.status === 201) {
            const { clientId } = response.data; // Extract clientId from the response
            localStorage.setItem('clientId', clientId); // Store clientId in localStorage

            alert('Registration successful! You will be contacted for account activation.');
            navigate('/confirmation');
        } else {
            throw new Error('Registration failed');
        }
    } catch (error) {
       
        const errorMessage = error.response?.data?.error || 'Registration failed. Please try again.';
        setError(errorMessage);
    }
};
  const calcExtraCost = () => {
    const extras =
      Math.max(0, formData.numberOfAccountants - packageConfig[formData.package].accountants) * 5 +
      Math.max(0, formData.numberOfDispatchers - packageConfig[formData.package].dispatchers) * 5 +
      Math.max(0, formData.numberOfDrivers - packageConfig[formData.package].drivers) * 3.49 +
      Math.max(0, formData.numberOfTrucks - packageConfig[formData.package].trucks) * 3.49;
    return parseFloat(extras.toFixed(2));
  };

  const basePrice = packagePricing[formData.package]
    ? packagePricing[formData.package][billingCycle]
    : 0;

  const totalPrice = basePrice + calcExtraCost();


  return (
    <div className={styles.containerRegister}>
       <video className={styles.RegisterPageVideoBackground} autoPlay loop muted>
              <source src={videoBackground} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
      <div className={styles.logoRegister} onClick={() => navigate('/login')}>
        <span className={styles.logoPart1Register}>Full</span> <span className={styles.logoPart2Register}>Trucking</span> <span className={styles.logoPart1Register}>Service</span>
      </div>
      <div className={styles.registerInfoMessage}>
  For now, registration is free. We will contact you to activate your account with all features for testing purposes!
</div>
      <form onSubmit={handleSubmit} className={styles.registerForm}>
  <h2 className={styles.registerTitle}>Welcome to FTS</h2>
  <p className={styles.registerSubtitle}>Create your account and start your journey</p>

        <div className={styles.formRowRegister}>
          <input
            type="text"
            name="companyName"
            placeholder="Company Name"
            value={formData.companyName}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="companyAddress"
            placeholder="Company Address"
            value={formData.companyAddress}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles.formRowRegister}>
          <input
            type="text"
            name="firstName"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="lastName"
            placeholder="Last Name"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles.formRowRegister}>
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="phone"
            placeholder="Phone"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles.formRowRegister}>
          <input
            type="text"
            name="fax"
            placeholder="Fax Number (optional)"  // Adăugat input Fax Number
            value={formData.fax}
            onChange={handleChange}
          />
        </div>
        <div className={styles.formRowRegister}>
          <input
            type="text"
            name="mcNumber"
            placeholder="MC Number"
            value={formData.mcNumber}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles.formRowRegister}>
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirm Password"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles.formRowRegister}>
  <textarea
    name="notes"
    placeholder="Additional Notes (optional)"
    value={formData.notes}
    onChange={handleChange}
    className={styles.notesInput}
  />
</div>

<div className={styles.resourcesContainer}>
  {/* === ACCOUNTANTS === */}
  <div
    className={`${styles.resourceCard} ${
      formData.numberOfAccountants > packageConfig[formData.package].accountants
        ? styles.overLimit
        : styles.included
    }`}
  >
    <h4>Accountants</h4>
    <input
      type="number"
      name="numberOfAccountants"
      min={packageConfig[formData.package].accountants}
      value={formData.numberOfAccountants}
      onChange={handleChange}
    />
    {formData.numberOfAccountants > packageConfig[formData.package].accountants ? (
      <p>
        Included: {packageConfig[formData.package].accountants}. Extra:{" "}
        {formData.numberOfAccountants - packageConfig[formData.package].accountants} × $5 ={" "}
        ${(formData.numberOfAccountants - packageConfig[formData.package].accountants) * 5} / month
      </p>
    ) : (
      <p>You have {packageConfig[formData.package].accountants} included in {formData.package}.</p>
    )}
  </div>

  {/* === DISPATCHERS === */}
  <div
    className={`${styles.resourceCard} ${
      formData.numberOfDispatchers > packageConfig[formData.package].dispatchers
        ? styles.overLimit
        : styles.included
    }`}
  >
    <h4>Dispatchers</h4>
    <input
      type="number"
      name="numberOfDispatchers"
      min={packageConfig[formData.package].dispatchers}
      value={formData.numberOfDispatchers}
      onChange={handleChange}
    />
    {formData.numberOfDispatchers > packageConfig[formData.package].dispatchers ? (
      <p>
        Included: {packageConfig[formData.package].dispatchers}. Extra:{" "}
        {formData.numberOfDispatchers - packageConfig[formData.package].dispatchers} × $5 ={" "}
        ${(formData.numberOfDispatchers - packageConfig[formData.package].dispatchers) * 5} / month
      </p>
    ) : (
      <p>You have {packageConfig[formData.package].dispatchers} included in {formData.package}.</p>
    )}
  </div>

  {/* === DRIVERS === */}
  <div
    className={`${styles.resourceCard} ${
      formData.numberOfDrivers > packageConfig[formData.package].drivers
        ? styles.overLimit
        : styles.included
    }`}
  >
    <h4>Drivers</h4>
    <input
      type="number"
      name="numberOfDrivers"
      min={packageConfig[formData.package].drivers}
      value={formData.numberOfDrivers}
      onChange={handleChange}
    />
    {formData.numberOfDrivers > packageConfig[formData.package].drivers ? (
      <p>
        Included: {packageConfig[formData.package].drivers}. Extra:{" "}
        {formData.numberOfDrivers - packageConfig[formData.package].drivers} × $3.49 ={" "}
        {((formData.numberOfDrivers - packageConfig[formData.package].drivers) * 3.49).toFixed(2)} / month
      </p>
    ) : (
      <p>You have {packageConfig[formData.package].drivers} included in {formData.package}.</p>
    )}
  </div>

  {/* === TRUCKS === */}
  <div
    className={`${styles.resourceCard} ${
      formData.numberOfTrucks > packageConfig[formData.package].trucks
        ? styles.overLimit
        : styles.included
    }`}
  >
    <h4>Trucks</h4>
    <input
      type="number"
      name="numberOfTrucks"
      min={packageConfig[formData.package].trucks}
      value={formData.numberOfTrucks}
      onChange={handleChange}
    />
    {formData.numberOfTrucks > packageConfig[formData.package].trucks ? (
      <p>
        Included: {packageConfig[formData.package].trucks}. Extra:{" "}
        {formData.numberOfTrucks - packageConfig[formData.package].trucks} × $3.49 ={" "}
        {((formData.numberOfTrucks - packageConfig[formData.package].trucks) * 3.49).toFixed(2)} / month
      </p>
    ) : (
      <p>You have {packageConfig[formData.package].trucks} included in {formData.package}.</p>
    )}
  </div>
</div>



  <div className={styles.billingCycleToggle}>
  <label>
    <input
      type="radio"
      value="monthly"
      checked={billingCycle === "monthly"}
      onChange={(e) => setBillingCycle(e.target.value)}
    />
    Monthly
  </label>
  <label>
    <input
      type="radio"
      value="annual"
      checked={billingCycle === "annual"}
      onChange={(e) => setBillingCycle(e.target.value)}
    />
    Annual (2 months free)
  </label>
</div>

<div className={styles.packagePricingBox}>
  <h4>Pricing</h4>
  <p>Base {formData.package} package: ${basePrice} / {billingCycle}</p>
  {calcExtraCost() > 0 && (
    <p>Extras: +${calcExtraCost()} / month</p>
  )}
  <strong>Total: ${totalPrice} / {billingCycle}</strong>
</div>

<div className={styles.disclaimerBox}>
  <p>
    Every package includes a 30-day free trial if you choose monthly.  
    Annual packages include a 14-day cancellation period.  
    You do not pay anything now.  
    After verification, if you do not want to be contacted, leave this in the notes.  
    We verify your data very quickly and activate your account.  
    You can test free of charge (30 days / annual cancellation) without providing any bank details.  
    After the trial period, you can decide to purchase the account.  
  </p>
</div>
{/* ✅ Checkbox pentru consimțământ GDPR */}
<div className={styles.privacyAgreementRegister}>
  <input
    type="checkbox"
    id="privacyCheck"
    checked={agreeToPrivacy}
    onChange={() => setAgreeToPrivacy(!agreeToPrivacy)}
    required
  />
  <label htmlFor="privacyCheck">
    I agree to be contacted and understand that my data will be processed according to the{' '}
    <a
      href="https://2-bfs.com/privacy-policy"
      target="_blank"
      rel="noopener noreferrer"
    >
      Privacy Policy
    </a>.
  </label>
</div>
        <div className={styles.packageRegister}>Selected Package: {formData.package}</div>
        {error && <p className={styles.errorMessageRegister}>{error}</p>}
        <button type="submit" className={styles.registerButton}>Register</button>
      </form>
    
    </div>
    
  );
};

export default RegisterPage;
